<div class="text-gray-1">
  <app-spinner></app-spinner>
  <router-outlet></router-outlet>
  <avla-notification></avla-notification>
  <app-modal-contact-form></app-modal-contact-form>
  <app-modal-tour></app-modal-tour>
</div>